$(document).ready(function() {
  // Play/Pause functionality on clicking the play button
  $('.module--video__thumbnail__icon').on('click', function() {
      var video = $(this).siblings('video')[0];
      if (video.paused) {
          video.play();
          $(this).hide();
      } else {
          video.pause();
          $(this).show();   
      }
  });

  // Pause/Play functionality when clicking the video itself
  $('video').on('click', function() {
      if (this.paused) {
          this.play();
          $(this).siblings('.module--video__thumbnail__icon').hide();  
      } else {
          this.pause();
          $(this).siblings('.module--video__thumbnail__icon').show();
      }
  });
});
